import request from '@/utils/request'

// 获取配置
export const config = (params) => {
    return request.get('/config', { params })
}
// 获取cos上传密钥
export const costempsecret = (params) => {
    return request.get('/upload/cos-temp-secret', { params })
}